export default {
  name: 'oButtonBack',
  props: {
    label: String
  }
};
